import { createContext } from 'react';

import { MemoryContextInterface, DefaultInterface } from '../../models/services/memory-context-interface';

const MemoryContext = createContext<MemoryContextInterface>(DefaultInterface);

export { MemoryContext };